import * as React from 'react'
export const Jp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" width="1em" height="1em" {...props}>
    <path fill="#FFF" d="M0 0h512v342H0z" />
    <circle cx={256.5} cy={171} r={96} fill="#D80027" />
  </svg>
)
